<span class="ms-large-b block font-body-1">
  {{ 'CORPORATE.corporatePortal.addUser.personalDetailsDescription' | finLocalization }}
</span>

<div class="col-3">
  <div class="col">
    <fin-select-input
      [parentForm]="formGroup"
      [controlName]="'salutation'"
      [options]="salutations$ | async"
      [selectLabelTranslationKey]="
        'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.salutation.unselected'
      "
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.salutation'"
    ></fin-select-input>
  </div>
  <div class="col">
    <fcom-text-input
      [parentForm]="formGroup"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName'"
      [controlName]="'firstName'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.firstName.placeholder'"
    ></fcom-text-input>
  </div>
  <div class="col">
    <fcom-text-input
      [parentForm]="formGroup"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName'"
      [controlName]="'lastName'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.familyName.placeholder'"
    ></fcom-text-input>
  </div>
</div>
<div>
  <fcom-text-input
    [parentForm]="formGroup"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email'"
    [controlName]="'email'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.email.placeholder'"
  ></fcom-text-input>
</div>
<div class="col-2">
  <div class="col">
    <fin-select-input
      [parentForm]="formGroup"
      [controlName]="'phonePrefix'"
      [options]="phonePrefixes$ | async"
      [selectLabelTranslationKey]="
        'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix.unselected'
      "
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phonePrefix'"
    ></fin-select-input>
  </div>
  <div class="col">
    <fcom-text-input
      [parentForm]="formGroup"
      [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber'"
      [controlName]="'phoneNumber'"
      [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.phoneNumber.placeholder'"
    ></fcom-text-input>
  </div>
</div>
<div>
  <fcom-text-input
    [parentForm]="formGroup"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle'"
    [controlName]="'workTitle'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.joinCorporateForm.fields.jobTitle.placeholder'"
  ></fcom-text-input>
</div>
<div>
  <fin-datepicker
    [parentForm]="formGroup"
    [controlName]="'dateOfBirth'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.fields.dateOfExpiry.placeHolder'"
    [minDate]="minBirthDate"
    [maxDate]="maxBirthDate"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.dateOfBirth'"
    [icon]="SvgLibraryIcon.CALENDAR"
    [theme]="DatepickerTheme.WEB_2"
  ></fin-datepicker>
</div>
<div>
  <fcom-text-input
    [parentForm]="formGroup"
    [translationPrefix]="'SERVICE_FORMS.CSServiceForms.fields.memberNumber'"
    [controlName]="'fPlusNumber'"
    [placeHolder]="'SERVICE_FORMS.CSServiceForms.fields.memberNumber.placeholder'"
  ></fcom-text-input>
</div>
